import script from "./ShortLinkTool.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortLinkTool.vue?vue&type=script&setup=true&lang=js"

import "./ShortLinkTool.vue?vue&type=style&index=0&id=af2c7166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af2c7166"]])

export default __exports__